// extracted by mini-css-extract-plugin
export default {"reportListTitle":"styles_reportListTitle__cfJo0"};